import React from "react";
import { LocalizationProvider, StaticDatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import moment from "moment";

export const SetExpiryDatePicker = ({
  setDatepicker,
  localDate,
  setLocalDate,
}) => {
  const nextDays = [7, 14, 30, 90];
  const handleNextDays = (e) => {
    if (e == "lifetime") {
      setLocalDate("");
    } else {
      let today = moment();
      let NextDate = moment(today.add(e, "days")).format("YYYY/MM/DD");
      setLocalDate(NextDate);
      setDatepicker(false);
    }
  };
  const handleDateChange = (e) => {
    let date = moment(e).format("YYYY/MM/DD");
    setLocalDate(date);
  };
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div className="d-flex">
          <div>
            <StaticDatePicker
              displayStaticWrapperAs="desktop"
              className="staticDatePicker"
              value={localDate}
              onChange={(newValue) => handleDateChange(newValue)}
              shouldDisableDate={(date) =>
                moment(date).isBefore(moment(), "day")
              }
            />
          </div>
          <div
            style={{
              borderLeft: "0.1rem solid #dee2e6",
              marginTop: "4rem",
              marginLeft: "-0.5rem",
            }}
          >
            <ul className="share-date-ul">
              {nextDays?.map((day, i) => (
                <li
                  key={i}
                  className="p-10 cursor-pointer"
                  value={day}
                  onClick={(e) => handleNextDays(e.target.value)}
                >
                  Next {day} days
                </li>
              ))}
              <li
                className="p-10 cursor-pointer"
                value="lifetime"
                onClick={(e) => handleNextDays(e.target.value)}
              >
                No expiry
              </li>
            </ul>
          </div>
        </div>
      </LocalizationProvider>
    </div>
  );
};
